import { lazy, object, number } from 'yup';

export const meterReadingStepSchema = lazy(fields =>
  object({
    counters: object(
      Object.entries(fields.counters).reduce(
        (validators, [key]) => ({
          ...validators,
          [key]: number().required(),
        }),
        {},
      ),
    ).required(),
  }).required(),
);
